module.exports = new __parcel__URL__("space_elixir_mine_level_10.663e22c9.png").toString();